import React, { FC, Fragment } from 'react';
import { formatDate } from 'utils/format';
import { Order } from 'models/order';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/system';
import { List, ListItemButton, ListItemText } from '@mui/material';
import { OrderForm } from 'models/order-form';
import OrderFormDialog from 'components/order-forms/order-form-dialog/order-form-dialog.component';
import InfoText from 'components/shared/info-text.component';

type OrderFormsSectionProps = {
    order: Order;
};
const OrderFormsSection: FC<OrderFormsSectionProps> = ({ order }: OrderFormsSectionProps) => {
    const { t: translate } = useTranslation(['orders']);
    const [isDialogOpen, setIsDialogOpen] = React.useState(false);
    const [currentOrderForm, setCurrentOrderForm] = React.useState<OrderForm>();

    const createdByText = (orderForm: OrderForm) => {
        return `${orderForm.createdBy.fullName}, ${formatDate(orderForm.createdAt, 'date')}`;
    };

    const handleItemClick = (orderForm: OrderForm) => {
        setIsDialogOpen(true);
        setCurrentOrderForm(orderForm);
    };

    return (
        <Fragment>
            {order.orderForms.length > 0 ? (
                <Box>
                    <List>
                        {order.orderForms.map((orderForm, index) => (
                            <ListItemButton
                                key={orderForm._id}
                                onClick={() => handleItemClick(orderForm)}
                                data-test={`order-form-${index}`}
                            >
                                <ListItemText
                                    primary={orderForm.title}
                                    secondary={`${translate('order-forms:SCANNED_BY')} ${createdByText(orderForm)}`}
                                />
                            </ListItemButton>
                        ))}
                    </List>
                </Box>
            ) : (
                <Box>
                    <InfoText text={translate('orders:NO_ATTACHED_ORDER_FORMS')} />
                </Box>
            )}

            <OrderFormDialog
                open={isDialogOpen}
                onClose={() => setIsDialogOpen(false)}
                partialOrderForm={currentOrderForm}
            />
        </Fragment>
    );
};

export default OrderFormsSection;
